import { ref, computed } from 'vue'

const players = ref({})

export const useMusicPlayer = (key) => {
    const player = computed(() => players.value[key].value)

    ;(() => {
        if (!players.value[key]) {
            players.value[key] = ref([])
        }
    })()

    return {
        players,
        player
    }
}
